<section class="breadcrumb-section">
  <div class="container">
    <div class="breadcrumb-content">
      <nav aria-label="breadcrumb">
        <ul class="breadcrumb-list">
          @for (item of items; track item.label; let last = $last) {
            <li class="breadcrumb-item" [class.active]="last">
              @if (item.url && !last) {
                <a [routerLink]="item.url">{{ item.label }}</a>
              } @else {
                <span>{{ item.label }}</span>
              }
              @if (!last) {
                <span class="separator">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="chevron">
                    <path d="M9 18l6-6-6-6"/>
                  </svg>
                </span>
              }
            </li>
          }
        </ul>
      </nav>
      
      <h1 class="page-title">{{ title }}</h1>
      @if (description) {
        <p class="page-description">{{ description }}</p>
      }
    </div>
  </div>
</section>
